import * as R from 'ramda'
import { SeenPatch } from '@weblite/ts-action/room'
import {
  DBFind,
  DBFindOne,
  DBInsert,
  DBRemove,
  DBRemoveMany,
  DBUpdateOne,
} from '@weblite/persist'

// TODO is mutex needed here?
const SEEN_COLLECTION = 'seenSync'

interface SeenPatchSync {
  roomId: string
  type: SeenPatch['type']
  seen: SeenPatch['seen']
  events: Record<number, number>
  ignoreUpdateRoomSeen: SeenPatch['ignoreUpdateRoomSeen']
}

export async function set(
  roomId: string,
  passedDeletedUnseen: number,
  seen: number,
  roomType: SeenPatch['type'],
  ignoreUpdateRoomSeen: boolean,
) {
  const { nextKey } = (await DBFindOne(SEEN_COLLECTION, roomId)) || {}
  if (nextKey) {
    await DBUpdateOne(SEEN_COLLECTION, roomId, {
      $inc: { nextKey: 1 },
      $set: {
        seen,
        [`events.${nextKey}`]: passedDeletedUnseen,
        ignoreUpdateRoomSeen,
      },
    })
  } else {
    await DBInsert(SEEN_COLLECTION, {
      nextKey: 2,
      seen,
      roomId,
      type: roomType,
      ignoreUpdateRoomSeen,
      events: { '1': passedDeletedUnseen },
    })
  }
}

export async function getAll() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const seenPatches: SeenPatchSync[] = await DBFind(SEEN_COLLECTION)

  async function unsetSeenPatch() {
    await Promise.all(
      seenPatches.map(seenPatch =>
        DBUpdateOne(SEEN_COLLECTION, seenPatch.roomId, {
          $unset: R.fromPairs(
            R.keys(seenPatch.events).map(key => [`events.${key}`, 1]),
          ),
        }),
      ),
    )
  }

  const pruneList: string[] = []

  const items = seenPatches
    .map(seenPatch => {
      if (R.isEmpty(seenPatch.events)) {
        pruneList.push(seenPatch.roomId)
        return null
      }
      return R.reduce(
        (acc, index: number) => ({
          ...acc,
          passedDeletedUnseen:
            acc.passedDeletedUnseen + seenPatch.events[index],
        }),
        {
          seen: seenPatch.seen,
          roomId: seenPatch.roomId,
          ignoreUpdateRoomSeen: seenPatch.ignoreUpdateRoomSeen,
          passedDeletedUnseen: 0,
          type: seenPatch.type,
        },
        R.sort((a, b) => +a - +b, R.keys(seenPatch.events)),
      )
    })
    .filter(Boolean)
    .map(({ ignoreUpdateRoomSeen, ...other }) => ({
      ...other,
      ignoreUpdateRoomSeen: ignoreUpdateRoomSeen || undefined,
    }))

  if (pruneList.length) await DBRemoveMany(SEEN_COLLECTION, pruneList)

  return { items, del: unsetSeenPatch }
}

/** Remove connected fields */
export async function del(roomId: string): Promise<void> {
  await DBRemove(SEEN_COLLECTION, roomId)
}
